<div id="user-display" *ngIf="isLogged()" class="btn" (click)="toggleDropdown()" [style]="{'color': mainColor}">
    <i class="fa fa-user-circle" style="font-size: 2em;" [style]="{'color': mainColor}"></i>{{username()}}
</div>
<div class="dropdown" [class.open]="isOpen()">
    <a id="logout" *ngIf="isLogged()"  (click)="logout()" class="btn" [style]="{'color': mainColor}">Sign out</a>
</div>
